export const STATUSES = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  INACTIVE: 'inactive',
  PENDING: 'pending',
  CANCELED: 'canceled',
};
